import deesseAuxGrenades, {
  ReactComponent as DeesseAuxGrenadesIcon,
} from "../assets/medaillons-lecture/déesse-aux-grenades.svg";
import gorgonne, { ReactComponent as GorgonneIcon } from "../assets/medaillons-lecture/gorgonne.svg";
import poseidon, { ReactComponent as PoseidonIcon } from "../assets/medaillons-lecture/poseidon.svg";
import roiSoleil, { ReactComponent as RoiSoleilIcon } from "../assets/medaillons-lecture/roi-soleil.svg";
import athena, { ReactComponent as AthenaIcon } from "../assets/medaillons-lecture/athena.svg";
import artemis, { ReactComponent as ArtemisIcon } from "../assets/medaillons-lecture/artemis.svg";
import dionysos, { ReactComponent as DionysosIcon } from "../assets/medaillons-lecture/dionysos.svg";
import hermes, { ReactComponent as HermesIcon } from "../assets/medaillons-lecture/hermes.svg";
import aphrodite, { ReactComponent as AphroditeIcon } from "../assets/medaillons-lecture/aphrodite.svg";
import zeus, { ReactComponent as ZeusIcon } from "../assets/medaillons-lecture/zeus.svg";
import demeter, { ReactComponent as DemeterIcon } from "../assets/medaillons-lecture/demeter.svg";
import hades, { ReactComponent as HadesIcon } from "../assets/medaillons-lecture/hades.svg";
import christ, { ReactComponent as ChristIcon } from "../assets/medaillons-lecture/christ.svg";
import ange, { ReactComponent as AngeIcon } from "../assets/medaillons-lecture/ange.svg";
import marie, { ReactComponent as MarieIcon } from "../assets/medaillons-lecture/marie.svg";
import sphinx, { ReactComponent as SphinxIcon } from "../assets/medaillons-lecture/sphinx.svg";
import hera, { ReactComponent as HeraIcon } from "../assets/medaillons-lecture/hera.svg";
import hypnos, { ReactComponent as HypnosIcon } from "../assets/medaillons-lecture/hypnos.svg";
import amazone, { ReactComponent as AmazoneIcon } from "../assets/medaillons-lecture/amazone.svg";
import jeanne, { ReactComponent as JeanneIcon } from "../assets/medaillons-lecture/jeanne.svg";
import heracles, { ReactComponent as HeraclesIcon } from "../assets/medaillons-lecture/heracles.svg";
import cleopatre, { ReactComponent as CleopatreIcon } from "../assets/medaillons-lecture/cleopatre.svg";
import hibou, { ReactComponent as HibouIcon } from "../assets/medaillons-lecture/hibou.svg";
import saintEsprit, { ReactComponent as SaintEspritIcon } from "../assets/medaillons-lecture/saint-esprit.svg";

export const LIBRARY_READING_DEFAULT_MEDALLION_ID = "deesse-aux-grenades";

export const LIBRARY_READING_MEDALLIONS = [
  { id: "amazone", label: "Amazone", src: amazone, Icon: AmazoneIcon },
  { id: "ange", label: "Ange", src: ange, Icon: AngeIcon },
  { id: "aphrodite", label: "Aphrodite", src: aphrodite, Icon: AphroditeIcon },
  { id: "artemis", label: "Artémis", src: artemis, Icon: ArtemisIcon },
  { id: "athena", label: "Athéna", src: athena, Icon: AthenaIcon },
  { id: "cleopatre", label: "Cléopâtre", src: cleopatre, Icon: CleopatreIcon },
  { id: "demeter", label: "Déméter", src: demeter, Icon: DemeterIcon },
  { id: "dionysos", label: "Dionysos", src: dionysos, Icon: DionysosIcon },
  { id: "roi-soleil", label: "Éleuthéria", src: roiSoleil, Icon: RoiSoleilIcon },
  { id: "gorgonne", label: "Gorgonne", src: gorgonne, Icon: GorgonneIcon },
  { id: "hades", label: "Hadès", src: hades, Icon: HadesIcon },
  { id: "hera", label: "Héra", src: hera, Icon: HeraIcon },
  { id: "heracles", label: "Héraclès", src: heracles, Icon: HeraclesIcon },
  { id: "hermes", label: "Hermès", src: hermes, Icon: HermesIcon },
  { id: "hibou", label: "Hibou", src: hibou, Icon: HibouIcon },
  { id: "hypnos", label: "Hypnos", src: hypnos, Icon: HypnosIcon },
  { id: "jeanne", label: "Jeanne d'Arc", src: jeanne, Icon: JeanneIcon },
  { id: "christ", label: "Jésus-Christ", src: christ, Icon: ChristIcon },
  { id: "deesse-aux-grenades", label: "Madonne", src: deesseAuxGrenades, Icon: DeesseAuxGrenadesIcon },
  { id: "marie", label: "Marie", src: marie, Icon: MarieIcon },
  { id: "poseidon", label: "Poséidon", src: poseidon, Icon: PoseidonIcon },
  { id: "saint-esprit", label: "Saint-Esprit", src: saintEsprit, Icon: SaintEspritIcon },
  { id: "sphinx", label: "Sphinx", src: sphinx, Icon: SphinxIcon },
  { id: "zeus", label: "Zeus", src: zeus, Icon: ZeusIcon },
];

const MEDALLION_IDS = new Set(LIBRARY_READING_MEDALLIONS.map((item) => item.id));

export function sanitizeLibraryReadingMedallionId(value, fallback = LIBRARY_READING_DEFAULT_MEDALLION_ID) {
  const id = String(value || "").trim();
  return MEDALLION_IDS.has(id) ? id : fallback;
}

export function libraryReadingMedallionById(id) {
  const safeId = sanitizeLibraryReadingMedallionId(id);
  return (
    LIBRARY_READING_MEDALLIONS.find((item) => item.id === safeId) ||
    LIBRARY_READING_MEDALLIONS.find((item) => item.id === LIBRARY_READING_DEFAULT_MEDALLION_ID)
  );
}
